import { render } from "./WeatherWindSpeed.vue?vue&type=template&id=4db703ee"
import script from "./WeatherWindSpeed.vue?vue&type=script&lang=js"
export * from "./WeatherWindSpeed.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__